var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "drag_interview" }, [
    _c("div", { staticClass: "drag_top" }, [
      _c("div", { staticClass: "top_left" }, [
        _c(
          "div",
          {
            staticClass: "title ellipsis",
            staticStyle: { maxWidth: "180px" },
            attrs: { title: _vm.intvGroupTitle + " - " + _vm.intvLink }
          },
          [
            _vm._v(
              _vm._s(_vm.intvGroupTitle) +
                " - " +
                _vm._s(_vm.intvLink) +
                "\n      "
            )
          ]
        ),
        _vm._v(" "),
        _vm.timeRange
          ? _c(
              "div",
              {
                staticClass: "time_range",
                staticStyle: { "margin-left": "8px" }
              },
              [_vm._v(_vm._s(_vm.timeRange))]
            )
          : _vm._e(),
        _vm._v(" "),
        _c("div", { staticClass: "total_num" }, [
          _vm._v(
            "共" +
              _vm._s(_vm.interRoomNum) +
              "个面试间，已分配" +
              _vm._s(_vm.interviewerNum) +
              "位面试官"
          )
        ])
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "top_right cursor_pointer",
          on: { click: _vm.reassignRoom }
        },
        [
          _c("span", { staticClass: "kdfont kdfont-shanchu" }),
          _vm._v("清空并重新分配\n    ")
        ]
      )
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "drag_content_box" }, [
      _c(
        "div",
        { staticClass: "drag_content" },
        _vm._l(_vm.roomConfig, function(roomItem, roomIndex) {
          return _c(
            "div",
            { staticClass: "room_area" },
            [
              _c(
                "div",
                {
                  staticClass: "room_content",
                  class: { room_check: !roomItem.intvers.length && _vm.isCheck }
                },
                [
                  _c("div", { staticClass: "room_info" }, [
                    _c("i", { staticClass: "kdfont kdfont-zhuyefangzi2" }),
                    _vm._v(" "),
                    _c(
                      "span",
                      {
                        staticClass: "ellipsis",
                        staticStyle: { width: "50px" },
                        attrs: { title: roomItem.intvRoomName }
                      },
                      [_vm._v(_vm._s(roomItem.intvRoomName))]
                    )
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "inter_list" },
                    [
                      _c(
                        "draggable",
                        {
                          attrs: {
                            group: "intvroom",
                            animation: "100",
                            filter: ".forbid",
                            dragClass: "dragClass",
                            ghostClass: "ghostClass",
                            chosenClass: "chosenClass",
                            move: _vm.onMove
                          },
                          on: { end: _vm.onEnd, start: _vm.onStart },
                          model: {
                            value: roomItem.intvers,
                            callback: function($$v) {
                              _vm.$set(roomItem, "intvers", $$v)
                            },
                            expression: "roomItem.intvers"
                          }
                        },
                        [
                          _c(
                            "transition-group",
                            { attrs: { tag: "span" } },
                            [
                              _vm._l(roomItem.intvers, function(
                                interItem,
                                interIndex
                              ) {
                                return _c(
                                  "div",
                                  {
                                    key: interItem.id,
                                    staticClass: "inter_info"
                                  },
                                  [
                                    _c("i", {
                                      staticClass: "kdfont kdfont-wode3"
                                    }),
                                    _c(
                                      "span",
                                      {
                                        staticClass: "ellipsis",
                                        staticStyle: { width: "40px" },
                                        attrs: { title: interItem.name }
                                      },
                                      [_vm._v(_vm._s(interItem.name))]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        directives: [
                                          {
                                            name: "show",
                                            rawName: "v-show",
                                            value: interItem.master,
                                            expression: "interItem.master"
                                          }
                                        ],
                                        staticClass: "master"
                                      },
                                      [_c("span", [_vm._v("主")])]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        directives: [
                                          {
                                            name: "show",
                                            rawName: "v-show",
                                            value:
                                              !_vm.dragState &&
                                              !interItem.master,
                                            expression:
                                              "!dragState && !interItem.master"
                                          }
                                        ],
                                        staticClass:
                                          "op_setMaster cursor_pointer",
                                        on: {
                                          click: function($event) {
                                            $event.stopPropagation()
                                            $event.preventDefault()
                                            return _vm.setMaster(
                                              roomItem.intvers,
                                              interIndex
                                            )
                                          }
                                        }
                                      },
                                      [_c("span", [_vm._v("主")])]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        directives: [
                                          {
                                            name: "show",
                                            rawName: "v-show",
                                            value: !_vm.dragState,
                                            expression: "!dragState"
                                          }
                                        ],
                                        staticClass: "op_delete cursor_pointer",
                                        on: {
                                          click: function($event) {
                                            $event.stopPropagation()
                                            $event.preventDefault()
                                            return _vm.deleteIntver(
                                              roomItem.intvers,
                                              interIndex
                                            )
                                          }
                                        }
                                      },
                                      [_c("span")]
                                    )
                                  ]
                                )
                              }),
                              _vm._v(" "),
                              roomItem.intvers.length < 30
                                ? _c(
                                    "div",
                                    {
                                      key: "addnew",
                                      staticClass:
                                        "inter_info forbid inter_info_add cursor_pointer",
                                      on: {
                                        click: function($event) {
                                          return _vm.addIntver(roomIndex)
                                        }
                                      }
                                    },
                                    [
                                      _c("i", {
                                        staticClass: "kdfont kdfont-zengjia3"
                                      }),
                                      _vm._v("添加\n                ")
                                    ]
                                  )
                                : _vm._e()
                            ],
                            2
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ]
              ),
              _vm._v(" "),
              roomItem.intvers && roomItem.intvers.length
                ? _c(
                    "el-popconfirm",
                    {
                      attrs: {
                        "popper-class": "popConfirm",
                        "hide-icon": true,
                        title: "删除面试间连同面试官一并删除，确认删除？"
                      },
                      on: {
                        confirm: function($event) {
                          return _vm.deleteRoom(_vm.roomConfig, roomIndex)
                        }
                      }
                    },
                    [
                      _c("i", {
                        staticClass: "kdfont kdfont-guanbi7 cursor_pointer",
                        style: {
                          visibility:
                            roomItem.appfiles && roomItem.appfiles.length
                              ? "hidden"
                              : "inherit"
                        },
                        attrs: { slot: "reference" },
                        slot: "reference"
                      })
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              !(roomItem.intvers && roomItem.intvers.length)
                ? _c("i", {
                    staticClass: "kdfont kdfont-guanbi7 cursor_pointer",
                    style: {
                      visibility:
                        roomItem.appfiles && roomItem.appfiles.length
                          ? "hidden"
                          : "inherit"
                    },
                    on: {
                      click: function($event) {
                        return _vm.deleteRoom(_vm.roomConfig, roomIndex)
                      }
                    }
                  })
                : _vm._e()
            ],
            1
          )
        }),
        0
      )
    ]),
    _vm._v(" "),
    _vm.interRoomNum < 100
      ? _c(
          "div",
          {
            staticClass: "room_area_add cursor_pointer",
            on: { click: _vm.addRoom }
          },
          [
            _c("i", { staticClass: "kdfont kdfont-zengjia3" }),
            _vm._v("\n    添加面试间\n  ")
          ]
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }